<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "SymmetryLayout"
}
</script>

<style scoped>

</style>